import React, { FC } from 'react';
import Scrollbar from './scrollbar/Scrollbar';

interface ButtonProps {
    innerRef: React.Ref<HTMLButtonElement>;
    scrollbarRef?: React.MutableRefObject<Scrollbar>;
}

const GoToTopButton: FC<ButtonProps> = ({ innerRef, scrollbarRef }) => {

    return (
        <button ref={innerRef}
            className='btn btn-primary back-to-top d-flex align-items-center justify-content-center'
            onClick={() => !scrollbarRef?.current ? window.scrollTo(0, 0) : scrollbarRef.current.scrollToTop()}
        >
            <i className='bi bi-arrow-up-short'></i>
        </button>
    )

}

export default GoToTopButton;